import { useCallback, useEffect, useRef, useState } from 'react';
import './Calendar.scss';
import dayjs, { Dayjs } from 'dayjs';
import images from '../../assets/images';
import CustomCalendar from '../../components/CustomCalendar/CustomCalendar';
import AddEventForm from '../../components/AddEventForm/AddEventForm';
import { useLazyQuery, useMutation } from '@apollo/client';
import { ADD_FAVOURITE, DELETE_EVENT, GET_ALL_CALENDAR, REMOVE_FAVOURITE, UPDATE_EVENT_STATUS } from './api/CalendarQuery';
import ToasterWithMessage from '../../components/toaster';
import MaterialActionsOverlay, { MenuItemType } from '../../components/ActionsOverlay/MaterialActionsOverlay';
import ConfirmationPopup from '../../components/ConfirmationPopup/ConfirmationPopup';
import Loader from '../../components/Loader/Loader';
import { CREATE_SCHEDULE_DATE_FORMAT, FETCH_POLICY, SCHOOL_ADMIN } from '../../utils/constants';
import { useAppSelector } from '../../redux/app/hooks';
import { visibility } from '../../redux/slices/rightSideAd';
import { useDispatch } from 'react-redux';
import { READ_NOTIFICATIONS } from '../AdminDashboard/api/AdminDashboardQuery';
import { setRefetchNotification } from '../../redux/slices/authSlice';
import { Tooltip } from '@mui/material';
import { getScreenDimensions } from '../../utils/helper';
import MobileScreenHeader from '../../components/MobileScreenHeader/MobileScreenHeader';

export type CalendarDataType = {
  eId: string;
  eTitle: string;
  eOriginalTitle: string;
  eDescription: string;
  eDate: string;
  eIsPublish: string;
  favouritesByEId: any;
  feedsByEId: {
    nodes: [
        {
            fId: string;
        }
    ]
}
}


const Calendar = () => {

  const { exitIcon, ResetCode, DeleteClass, MenuShareIcon, MoreIconBig, ShareGif, DeleteGif, PencilIcon ,ActiveFavouriteIcon} = images;
  const [value, setValue] = useState<Dayjs | null>(dayjs());
  const [open, setOpen] = useState<boolean>(false);
  const [calendarData, setCalendarData] = useState<CalendarDataType[]>();
  const [allCalendarData, setAllCalendarData] = useState<CalendarDataType[]>();
  const { success, error } = ToasterWithMessage();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [openOverlay, setOpenOverlay] = useState<boolean>(false);
  const [action, setAction] = useState<string>('');
  const [openConfirmationPopup, setOpenConfirmationPopup] = useState<boolean>(false);
  const [selectedEvent, setSelectedEvent] = useState<CalendarDataType>();
  const [refetch, setRefetch] = useState<boolean>(false);
  const role = useAppSelector((state) => state.auth.role);
  const [favouritesData, setFavouritesData] = useState<CalendarDataType[]>([]);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const dispatch = useDispatch();
  const profile = useAppSelector((state) => state.auth.adminProfile);
  const [isFiltered, setIsFiltered] = useState<boolean>(false);
  const profileImage = useAppSelector((state) => state?.auth?.adminProfileImage);
  const StudentName = profile?.getCurrentUser?.nodes?.[0]?.uFullName;

  const menuItems: MenuItemType[] = [
    {
      icon: MenuShareIcon,
      label: "Share Event",
      onClick: () => {
        setAction('share');
        setOpenConfirmationPopup(true);
        handleCloseActions();
      }
    },
    {
      icon: PencilIcon,
      label: "Edit",
      onClick: () => {
        setOpen(true);
        setIsEdit(true);
        handleCloseActions();
      }
    },
    {
      icon: DeleteClass,
      label: "Delete",
      onClick: () => {
        setAction('delete');
        setOpenConfirmationPopup(true);
        handleCloseActions();
      }
    }
  ]
  const [menuItem, setMenuItem] = useState<MenuItemType[]>(menuItems);
  const [favouriteIsOpen,setfavouriteIsOpen] = useState<boolean>(false);


  const [GetAllEvents, { loading }] = useLazyQuery(GET_ALL_CALENDAR, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setCalendarData(data?.getAllEvents?.nodes)
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [GetAllEventsWithoutFilter] = useLazyQuery(GET_ALL_CALENDAR, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setAllCalendarData(data?.getAllEvents?.nodes)
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [GetAllFavourites] = useLazyQuery(GET_ALL_CALENDAR, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: (data) => {
      setFavouritesData(data?.getAllEvents?.nodes);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [UpdateEventStatus] = useMutation(UPDATE_EVENT_STATUS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {
      success(`Event ${action === "share" ? "published" : "unpublished"} succesfully`);
      setRefetch(!refetch);
      setSelectedEvent(undefined)
    },
    onError: (err) => {
      error(err?.message);
    }
  })

  const [deleteEvent] = useMutation(DELETE_EVENT, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {
      success("Event deleted succesfully");
      setOpen(false);
      setIsEdit(false);
      setSelectedEvent(undefined);
      setRefetch(!refetch);
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [addFavourite] = useMutation(ADD_FAVOURITE, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {
      if (value) {
        handleApiCall(value, isFiltered, false);
        handleGetAllFavouraties();
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [removeFavourite] = useMutation(REMOVE_FAVOURITE, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {
      if (value) {
        handleApiCall(value, isFiltered, false);
        handleGetAllFavouraties();
      }
    },
    onError: (err) => {
      error(err?.message);
    }
  });

  const [readNotification] = useMutation(READ_NOTIFICATIONS, {
    fetchPolicy: FETCH_POLICY,
    onCompleted: () => {},
    onError: (err) => {
        console.log("Error", err?.message);
    }
  })

  const handleApiCall = async (filterDate: Dayjs, isFilter: boolean, isFavourites: boolean) => {
    if (!open) {
      setIsFiltered(isFilter);
      setCalendarData(undefined);
      GetAllEvents({
        variables: {
          input: {
            date: filterDate.format(CREATE_SCHEDULE_DATE_FORMAT),
            limit: null,
            offset: null,
            isFilter: isFilter,
            isFavourites: isFavourites
          }
        }
      });
    }
  }

  const handleGetAllFavouraties = () => {
    GetAllFavourites({
      variables: {
        input: {
          date: dayjs().format(CREATE_SCHEDULE_DATE_FORMAT),
          limit: null,
          offset: null,
          isFilter: false,
          isFavourites: true
        }
      }
    });
  }

  useEffect(() => {
    handleApiCall(dayjs(), false, false);
    handleGetAllFavouraties();
  },[refetch])

  useEffect(() => {
    if (calendarData && calendarData?.length > 0 && (role !== SCHOOL_ADMIN)) {
      calendarData?.forEach((data) => {
        if (data?.feedsByEId?.nodes[0]?.fId) {
          readNotification({
            variables: {
              fId: data?.feedsByEId?.nodes[0]?.fId,
              uId: profile?.getCurrentUser?.nodes[0]?.uId
            }
          })
        }
      });
      dispatch(setRefetchNotification({ refetchNotification: true }));
    }
  },[calendarData])

  useEffect(() => {
    if (isEdit && selectedEvent) {
      setValue(dayjs(selectedEvent?.eDate))
    }
  }, [ isEdit ])

  useEffect(() => {
    if (open) {
      setIsFiltered(false);
      GetAllEvents({
        variables: {
          input: {
            date: dayjs().format(CREATE_SCHEDULE_DATE_FORMAT),
            limit: null,
            offset: null,
            isFilter: false,
            isFavourites: false
          }
        }
      });
    }
  }, [open])

  useEffect(() => {
    dispatch(visibility({ isVisible: false }));
  },[])

  useEffect(()=>{
    GetAllEventsWithoutFilter({
      variables: {
        input: {
          date: dayjs().format(CREATE_SCHEDULE_DATE_FORMAT),
          limit: null,
          offset: null,
          isFilter: false,
          isFavourites: false
        }
      }
    });
  },[calendarData]);


  useEffect(()=>{
    if(favouriteIsOpen){
      handleGetAllFavouraties()
    }

  },[favouriteIsOpen])
  

  const handleClickMoreIcon = (event: React.MouseEvent<HTMLElement>, calendar: CalendarDataType | undefined) => {
    event.stopPropagation();
    setIsEdit(false);
    if (calendar) {
      if (calendar?.eIsPublish) {
        const temp = [...menuItem];
        temp[0] = {
          icon: ResetCode,
          label: "Undo Shared",
          onClick: () => {
            setAction('unshare');
            handleCloseActions();
            handleEvents(calendar, 'unshare');
          }
        }
        setMenuItem(temp);
      }
      else {
        setMenuItem(menuItems);
      }
      setSelectedEvent(calendar);
      setAnchorEl(event.currentTarget);
      setOpenOverlay(true);
    }
  };

  const handleEvents = async (selectedData: CalendarDataType, actionType: string) => {
    if (actionType === "share") {
      UpdateEventStatus({
        variables: {
          input: {
            eId: selectedData?.eId,
            eIsPublish: true
          }
        }
      })
    }
    else if (actionType === "unshare") {
      UpdateEventStatus({
        variables: {
          input: {
            eId: selectedData?.eId,
            eIsPublish: false
          }
        }
      })
    }
    else if (actionType === "delete") {
      deleteEvent({
        variables: {
          eId: selectedData?.eId
        }
      })
    }
  }

  const onYesButtonClick = () => {
    setOpenConfirmationPopup(false);
    if (selectedEvent) {
      handleEvents(selectedEvent, action);
    }
  }

  const onNoButtonClick = () => {
    setOpenConfirmationPopup(false);
  }

  const handleCloseActions = () => {
    setAnchorEl(null);
    setOpenOverlay(false);
  };

  const handleClickFavourite = (data:CalendarDataType) =>{
      if(data?.favouritesByEId?.nodes?.[0]?.faId){
         removeFavourite({
          variables:{
            faId:data?.favouritesByEId?.nodes?.[0]?.faId
          }
         })
      }else{
        addFavourite({
          variables:{
            eId:data?.eId
          }
        })
      }
  }

  const handleClearFilter = () => {
    setValue(dayjs());
    setRefetch(!refetch);
  }
  const titleRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [ellipsisStates, setEllipsisStates] = useState<boolean[]>([]);

    // Function to check ellipsis state
    const updateEllipsisStates = useCallback(() => {
        setEllipsisStates(titleRefs.current.map(el => el ? el.scrollWidth > el.clientWidth : false));
    }, []);

    // Check ellipsis on mouse enter
    const handleMouseEnter = (index: number) => {
        if (titleRefs.current[index]) {
            const isEllipsis = titleRefs.current[index]!.scrollWidth > titleRefs.current[index]!.clientWidth;
            setEllipsisStates(prev => {
                const newStates = [...prev];
                newStates[index] = isEllipsis;
                return newStates;
            });
        }
    };

    // Listen for window resize
    useEffect(() => {
        window.addEventListener("resize", updateEllipsisStates);
        updateEllipsisStates(); // Initial check
        return () => window.removeEventListener("resize", updateEllipsisStates);
    }, [updateEllipsisStates]);


  return (

    // <div>
      <div className='CalendarMainSection'>
      { getScreenDimensions()?.isMobileScreen && 
      <MobileScreenHeader 
       profileImage={profileImage}
       role={role}
       studentName={StudentName}
       profile={profile}
       favouriteIsOpen = {favouriteIsOpen}
       setfavouriteIsOpen = {setfavouriteIsOpen}
       /> }
       <div className= 'CalendarMobileMainContainer'>
       { getScreenDimensions()?.isMobileScreen&&  
          <div className='CalenderMobileMidContainer'>
              {!favouriteIsOpen && <div className="calendarMobileHeaderContainer" >Calendar</div>}
              <div className={`CalendarContainer ${(role === SCHOOL_ADMIN) ? 'CalendarContainerAdmin' : ''}`}>
            <CustomCalendar value={value} setValue={setValue} favouritesData={favouritesData} allCalendarData={allCalendarData} open={open} setOpen={setOpen} handleApiCall={handleApiCall} isMobile = {true} favouriteIsOpen = {favouriteIsOpen} setfavouriteIsOpen={setfavouriteIsOpen} handleClearFilter = {handleClearFilter}/>
          </div>
        </div>
       }
      {
      ( !favouriteIsOpen) && 
      (((!loading || calendarData !== undefined)) ? (
        <div className='EventContainer'>
          {(open) && (<AddEventForm date={value} selectedData={selectedEvent} isEdit={isEdit}  setSelectedData={setSelectedEvent} setOpen={setOpen} setRefetch={setRefetch} refetch={refetch} setDate={setValue} setIsEdit={setIsEdit}/>)}
          <div className={`${(calendarData?.length === 0 && !open) ? 'noData' : 'EventInnerContainer'}`}>
            <div className="clearFilterBtnContainer" onClick={handleClearFilter}>
              <button className={`clearFilterBtn ${!isFiltered && "hideButton"}`}>Clear Filter</button>
            </div>
            { !(calendarData && calendarData?.length === 0 && !open) ? (calendarData && calendarData.map((val: CalendarDataType, index: number) => {
                return (
                  <div className='Events' key={index}>
                    {(index === 0 || !dayjs(val?.eDate).isSame(dayjs(calendarData?.[index - 1]?.eDate))) && (
                      <div className='EventDateContainer'>
                        <div className='activeIcon'>
                          {(index === 0) && (<img src={ exitIcon } className='Icon' alt='exitIcon'/>)}
                        </div>
                        <div className='date'>{ dayjs(val?.eDate).format('DD.MM.YY') }</div>
                        <div className={`${ index === 0 ? 'ActiveDivider' : 'divider' }`} />                    
                      </div>
                    )}
                    <div className='EventCard'>
                    <Tooltip 
                        key={index} 
                        title={val?.eOriginalTitle} 
                        disableHoverListener={!ellipsisStates[index]}
                    >
                        <div 
                            ref={el => titleRefs.current[index] = el}
                            className="EventCardTitle" 
                            onMouseEnter={() => handleMouseEnter(index)}
                        >
                            {val?.eOriginalTitle}
                        </div>
                    </Tooltip>
                      <div className={role === SCHOOL_ADMIN ? 'EventCardDescription':'TeacherStudentEventCartDescription'}>{ val?.eDescription }</div>
                      {role === SCHOOL_ADMIN && <div className="moreIconContainer" onClick={(event) => handleClickMoreIcon(event, val)} >
                        <img src={ MoreIconBig } alt="action" className='moreIcon'/>
                      </div>}
                      {(val?.eIsPublish && role === SCHOOL_ADMIN) && (
                        <div className='publishedContainer'>
                          <span>Published</span>
                          <div className='publishIcon' />
                        </div>
                      )}
                      {
                        role !== SCHOOL_ADMIN && (
                          <div className='favouriteCtn' onClick={()=>handleClickFavourite(val)}>
                           {val?.favouritesByEId?.nodes?.[0]?.faId ?
                             <div className='favouriteIcon'/> :
                             <div className='NotFavouriteIcon'/>
                           }
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              })) : <div className='noDataFoundStyle'>No data found</div>
            }
          </div>
        </div>
      ) :  <Loader />)}

{
      ( favouriteIsOpen) && 
      (((!loading || favouritesData !== undefined)) ? (
        <div className='EventContainer' >
          {(open) && (<AddEventForm date={value} selectedData={selectedEvent} isEdit={isEdit}  setSelectedData={setSelectedEvent} setOpen={setOpen} setRefetch={setRefetch} refetch={refetch} setDate={setValue} setIsEdit={setIsEdit}/>)}
          <div className={`${(calendarData?.length === 0 && !open) ? 'noData' : 'EventInnerContainer'}`} style = {{justifyContent:favouritesData.length ===0?"center":"normal"}}>
            {/* <div className="clearFilterBtnContainer" onClick={handleClearFilter}>
              <button className={`clearFilterBtn ${!isFiltered && "hideButton"}`}>Clear Filter</button>
            </div> */}
            { !(favouritesData && favouritesData?.length === 0 && !open) ? (favouritesData && favouritesData.map((val: CalendarDataType, index: number) => {
                return (
                  <div className='Events' key={index}>
                    {(index === 0 || !dayjs(val?.eDate).isSame(dayjs(favouritesData?.[index - 1]?.eDate))) && (
                      <div className='EventDateContainer'>
                        <div className='activeIcon'>
                          {(index === 0) && (<img src={ exitIcon } className='Icon' alt='exitIcon'/>)}
                        </div>
                        <div className='date'>{ dayjs(val?.eDate).format('DD.MM.YY') }</div>
                        <div className={`${ index === 0 ? 'ActiveDivider' : 'divider' }`} />                    
                      </div>
                    )}
                    <div className='EventCard'>
                    <Tooltip 
                        key={index} 
                        title={val?.eOriginalTitle} 
                        disableHoverListener={!ellipsisStates[index]}
                    >
                        <div 
                            ref={el => titleRefs.current[index] = el}
                            className="EventCardTitle" 
                            onMouseEnter={() => handleMouseEnter(index)}
                        >
                            {val?.eOriginalTitle}
                        </div>
                    </Tooltip>
                      <div className={role === SCHOOL_ADMIN ? 'EventCardDescription':'TeacherStudentEventCartDescription'}>{ val?.eDescription }</div>
                      {role === SCHOOL_ADMIN && <div className="moreIconContainer" onClick={(event) => handleClickMoreIcon(event, val)} >
                        <img src={ MoreIconBig } alt="action" className='moreIcon'/>
                      </div>}
                      {(val?.eIsPublish && role === SCHOOL_ADMIN) && (
                        <div className='publishedContainer'>
                          <span>Published</span>
                          <div className='publishIcon' />
                        </div>
                      )}
                      {
                        role !== SCHOOL_ADMIN && (
                          <div className='favouriteCtn'>
                           {
                            <img className="calendarIcon" alt="calendarIcon" src={ ActiveFavouriteIcon} />
                           }
                          </div>
                        )
                      }
                    </div>
                  </div>
                )
              })) : <div className='noDataFoundStyle' >No data found</div>
            }
          </div>
        </div>
      ) :  <Loader />)}

      
     { !getScreenDimensions()?.isMobileScreen && <div className={`CalendarContainer ${(role === SCHOOL_ADMIN) ? 'CalendarContainerAdmin' : ''}`}>
        <CustomCalendar value={value} setValue={setValue} favouritesData={favouritesData} allCalendarData={allCalendarData} open={open} setOpen={setOpen} handleApiCall={handleApiCall} isMobile = {false} favouriteIsOpen = {favouriteIsOpen} setfavouriteIsOpen={setfavouriteIsOpen} handleClearFilter = {handleClearFilter}/>
      </div>}
      <MaterialActionsOverlay
        anchorEl={anchorEl}
        open={openOverlay}
        handleClose={handleCloseActions}
        menuItems={menuItem}
        actionsHeight={'110px'}
        position="right"
        verticalPosition="bottom"
      />
      <ConfirmationPopup
        open={openConfirmationPopup}
        message={action === "share" ? `Are you sure you want to Share this Schedule with the School?` : `Are you sure you want to Delete this Schedule from the School?`}
        gifData={action === "share" ? ShareGif : DeleteGif}
        yesButtonFunctionality={onYesButtonClick}
        noButtonFunctionality={onNoButtonClick}
        messageWidth={'195px'}
      />
       </div>
      
      </div>
    // </div>
   
  );
}

export default Calendar;
